module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_null_1@2x.63655283.png";